import { inject } from '@angular/core';
import { catchError, EMPTY, Observable } from 'rxjs';
import { WIZARD_CONTROLLER } from '@mwe/features/wizard';
import { IkpPopupService } from '@shared-ikp/service/popup/popup.service';
import { Ummeldung } from '../../../../generated/model/ummeldung.model';
import { UmmeldungStore } from '../ummeldung.store';
import { stepFormOf } from './wizardStepForm.util';
import AktuellerProzessSchrittEnum = Ummeldung.AktuellerProzessSchrittEnum;

/**
 * "Speichern und später fortsetzen": validates the step on screen, commits its draft and persists
 * the Ummeldung with that step as `aktuellerProzessSchritt`. Returns `null` when nothing was saved
 * — the step is invalid (its errors are now visible) or a save is already running. Call in an
 * injection context and keep the returned function.
 */
export function injectUmmeldungDraftSaver(): () => Observable<void> | null {
  const store = inject(UmmeldungStore);
  const wizardController = inject(WIZARD_CONTROLLER);
  const popupService = inject(IkpPopupService);

  return () => {
    const step = wizardController.currentStep();
    const draft = stepFormOf(step?.context);

    if (store.loading() || draft?.touchAndValidate() === false) {
      return null;
    }
    draft?.commitDraft();

    return store.saveActiveUmmeldung((step?.stepId as AktuellerProzessSchrittEnum | undefined) ?? null).pipe(
      catchError(() => {
        popupService.handleErrorPopup('save-ummeldung-error', 'ummeldung.saveErrorPopup.title', 'ummeldung.saveErrorPopup.message', true);
        return EMPTY;
      }),
    );
  };
}
